<template>
	<div class="vh-100 bg-grey">
		<!-- HEADER -->
		<div class="header-top bg-white">

			<!-- Normal Header -->
			<div class="fixed-judul fixed-top">
				<div class="row justify-content-center align-items-center set-row w-limit">
					<div class="col-md-2 col-sm-2 col-2 remove-padding">
						<div @click="RouteToDashboard">
							<div class="header-icon icon-arrow-left"></div>
						</div>
					</div>
					<div class="col-md-8 col-sm-8 col-8 text-center remove-padding">
						<h6 class="remove-margin font-16 font-colorcheck text-promo nomore">
							EDC
						</h6>
					</div>
					<div data-v-8dbe3aee="" class="col-md-2 col-sm-2 col-2"></div>
				</div>
			</div>
		</div>

		<!-- MAIN NORMAL CONTENT -->
		<main class="page-wrapper main-page w-limit">
			<div>
				<div class="main-content-data">
					<div class="total-text">Total <span class="total-text-bold">{{ kasEDC | currency}}</span></div>
					<div class="tanggal-text">Terhitung {{ tanggal }}</div>
					<div class="list-card">
						<div class="flex-1" v-for="data in dataList" :key="data.nama_akun">
							<div class="set-card set-card-height">
								<div class="row add-padding-default">
									<div class="col-md-12 col-sm-12 col-12  remove-padding">
										<div class="font-16 remove-margin font-weight-bold nomore">
											{{ data.nama_akun }}
										</div>
										<div class="font-16 remove-margin nomore">
											{{ data.saldo_akhir | currency }}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="loadmoreSpinner" id="loadingSpinner">
					<center>
						<div class="sp sp-circle"></div>
					</center>
				</div>
			</div>
		</main>
		<div class="loader"></div>
	</div>
</template>
<script>
export default {
	name: "ListKasEDC",
	data() {
		return {
			dataList: [],
			kasEDC:"Rp.0",
			tanggal:"-",
			requestHeaders: {
				headers: {
					'Authorization': 'Bearer ' + localStorage.getItem('token'),
				}
			},
		}
	},
	mounted() {
		$(".main-content-data").hide()
		$(".loader").hide()
		this.getDataKeuangan()
	},
	methods: {
		toTop(){
			window.scrollTo(0, 0)
		},
		RouteToDashboard() {
			this.$emit("ToChildDashboard")
		},
		async getDataKeuangan() {
			$(".loadmoreSpinner").show()
			try {
				const response = await this.$axios.get(this.$baseurl + '/masterData/meta/data_keuangan_dashboard', this.requestHeaders);
				if (response.data.code === 200) {
					if (response.data.status === true) {
						this.kasEDC = response.data.data.total_kas_edc
						this.tanggal = response.data.data.tanggal
						this.GetDataListEDC()
					} else {
						$(".loadmoreSpinner").hide()
						this.saldoPaylink = 0
					}
				} else {
					$(".loadmoreSpinner").hide()
					this.popupType = "error";
					this.popupMessage = response.data.msg;
				}
			} catch (e) {
				if (!e.code) {
					$(".loadmoreSpinner").hide()
					this.popupType = "error";
					this.popupErrorException = e;
				}
			}

		},
		async GetDataListEDC() {
			$(".loadmoreSpinner").show()
			try {
				const response = await this.$axios.get(this.$baseurl + '/masterData/meta/list_detail_kas_edc', this.requestHeaders)
				if (response.status === 200) {
					if (response.data.status === true) {
						var dataEach = response.data.data
						for (var i = 0; i < dataEach.length; i++) {
							this.dataList.push(
								{
									nama_akun: dataEach[i].nama_akun,
									saldo_akhir: dataEach[i].saldo_akhir
								}
							)
						}
						$(".main-content-data").show()
					} else {
						this.popupType = "error";
						this.popupMessage = response.data.msg;
					}
				} else {
					$(".loadmoreSpinner").hide()
					this.popupType = "error";
					this.popupMessage = response.data.msg;
				}
			} catch (e) {
				$(".loadmoreSpinner").hide()
				this.popupType = "error";
				this.popupErrorException = e;
			}
			$(".loadmoreSpinner").hide()
		},
	}
}
</script>
<style scoped>
.header-icon {
	height: 25px;
	width: 25px;
	background-position: center;
	background-size: cover;
	background-repeat: no-repeat;
}

.main-content-data {
	padding: 20px 20px;
}

.set-card-height {
	height: 80px;
}

.list-card {
	margin-top: 15px;
}

.total-text {
	font-family: Overpass;
	font-style: normal;
	font-weight: normal;
	font-size: 16px;
	line-height: 155%;
	display: flex;
	align-items: center;
	letter-spacing: -0.02em;
	color: #6F7287;
}

.total-text-bold {
	font-weight: bold;
	margin-left: 5px;
	color: #000000;
}

.tanggal-text {
	font-family: Overpass;
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	line-height: 150%;
	display: flex;
	align-items: center;
	letter-spacing: -0.02em;
	color: #6F7287;
}
</style>